module.exports = __webpack_public_path__ + "static/media/customPreAssessment.78448104.png";